import React from "react";
import Header from "../../components/VersatileComponents/Header";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import BranchCard from "../../components/Branch/BranchCard";
import useFilteredCollectionData from "../../hooks/sub_admin_use_filtered_collection_data";
import { useAuth } from "../../contexts/AuthContext";
import useDocumentById from "../../hooks/useDocumentById";
import useUserClaims from "../../hooks/useUserClaims";
import { Helmet } from "react-helmet-async";
import { useLocation, useParams } from "react-router-dom";
import getRequiredUserData from "../../utils/getBranchInfo";
const SUB_ADMIN_BRANCH_IDS_KEY = "subAdminBranchIds";
const SubAdminBranches = () => {
  const theme = useTheme();
  const { user } = useAuth();
  const userClaim = useUserClaims(user);
  const storedBranchIds = localStorage.getItem(SUB_ADMIN_BRANCH_IDS_KEY);
  const branchIdsArray = storedBranchIds ? storedBranchIds.split(",") : [];

  const { data: branches } = useFilteredCollectionData(
    "branches",
    "branchId",
    branchIdsArray
  );

  const location = useLocation();
  const basePath = "/mainsubAdmin";
  const startsWithMainsubAdmin = location.pathname.startsWith(basePath);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>SubAdmin Branch</title>
        {/* <link rel="canonical" href="http://localhost:3000/" /> */}
        <meta name="description" content="List of branches" />
      </Helmet>
      <Box
        m="1.5rem 2.5rem"
        sx={{
          backgroundColor: theme.palette.background.default,
          height: "100%",
          position: "relative",
        }}
      >
        {userClaim.subAdmin ? (
          <Grid container spacing={2} style={{ marginBottom: "50px" }}>
            <Grid
              item
              xs={6}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <Box flex="1">
                <Typography
                  variant="h2"
                  color={theme.palette.secondary[100]}
                  fontWeight="bold"
                  sx={{ mb: "5px" }}
                >
                  SubAdmin Branch
                </Typography>

                <Typography variant="h5" color={theme.palette.secondary[300]}>
                  Assigned list of Branches
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                //   margin: "0 30",
              }}
            ></Grid>
          </Grid>
        ) : null}
        {userClaim.superAdmin && !startsWithMainsubAdmin ? (
          <Header title="Branch" subtitle="Entire list of Branches" />
        ) : null}
        <Grid container spacing={2}>
          {branches?.map((item) => (
            <Grid key={item.id} item xs={6} sm={4} md={4} lg={4} xl={4}>
              <BranchCard branchData={item} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default SubAdminBranches;
